const Service = (type, action) => {
	let parsed = null;

	switch (type) {
		case "SEARCH": {
			const payload = {
				name: action.query,
				options: action.options || {},
			};
			parsed = { type: action.method, url: action.url, payload };
			break;
		}

		case "HASHTAGS": {
			parsed = {
				type: "GET",
				url: `/api/0.1/hashtags/?hashtag=${action.hashtag}`,
			};
			break;
		}

		default: {
			parsed = null;
			break;
		}
	}

	return parsed;
};

export default Service;
